import axiosInstance from "utils/axios";
import { accessToken } from "utils/state";

// ----------------------------------------------------------------------

export const saveForm = async (form: any) => {
    try {

        const response = await axiosInstance.post(form.url, form.payload, {
            headers: {
                'Authorization': `Token ${accessToken()}`
            }
        });
        return response;
    } catch (error) {
        return {
            status: 401,
            error
        };
    }
};

export const listSubmissions = async (req: any) => {
    try {
        const response = await axiosInstance.get(req.url, {
            params: req.params,
            headers: {
                'Authorization': `Token ${accessToken()}`
            }
        });
        return response;
    } catch (error) {
        return {
            status: 401,
            error
        };
    }
};
